export default function getLocationParamKey() {
  const urlSearchParams = new URLSearchParams(window.location.search);

  if (urlSearchParams.has('state')) return 'state';
  if (urlSearchParams.has('city')) return 'city';
}
